import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import weekday from "dayjs/plugin/weekday";
import "dayjs/locale/en";
import "dayjs/locale/sv";


//  function to replace suffix if any of the suffices exists, else add the suffix

export function replaceSuffix(column, type_value) {

  var _suffix = { "SUM": "_SUM", "ACC": "_ACC", "AVG": "" };
  let newSuffix = _suffix[type_value];
  // Check if any of the suffixes exist in the key
  let key = column.key;
  for (let suffix of ["_SUM", "_ACC"]) {
    if (key.endsWith(suffix)) {
      // Remove existing suffix and add new one
      return key.slice(0, -suffix.length) + newSuffix;
    }
  }
  // No existing suffix found, just add the new one
  return key + newSuffix;
}

export function changeSuffix(newColumns, type) {
  // check type.value and replace the key with the new key
  for (let i = 0; i < newColumns.length; i++) {
    if (newColumns[i].label === type.key) {
      newColumns[i].key = replaceSuffix(newColumns[i], type.value);
    }
  }
}



// checks if a version in format ex. 1.44.5345 is less than the required version
export function isVersionLessThan(version, requiredVersion) {
  // if either version or requiredVersion is null or undefined, return false
  if (!version || !requiredVersion) {
    return false;
  }

  const versionDots = (version.match(/\./g) || []).length;
  const requiredVersionDots = (requiredVersion.match(/\./g) || []).length;

  if (versionDots === requiredVersionDots) {
    // remove all non-numeric characters except the decimal point from the strings
    let v1parts = version.split(".").map(Number);
    let v2parts = requiredVersion.split(".").map(Number);

    // pad the shorter array with zeros
    while (v1parts.length < v2parts.length) v1parts.push(0);
    while (v2parts.length < v1parts.length) v2parts.push(0);

    for (let i = 0; i < v1parts.length; ++i) {
      if (v1parts[i] < v2parts[i]) {
        return true;
      } else if (v1parts[i] > v2parts[i]) {
        return false;
      }
    }

    // the versions are identical
    return false;
  } else {
    // fallback, remove all non-numeric characters and the decimal point from the strings
    version = parseFloat(version.replace(/[^0-9]/g, ""));
    requiredVersion = parseFloat(requiredVersion.replace(/[^0-9]/g, ""));

    return version < requiredVersion;
  }
}

export const transformToGroupByColumnsFromAPIResponse = columnTypes => ({
  config: {
    options: columnTypes
      .filter(col => col.hidden == false) // visa inte gömda kolumner
      .filter(col => col.showInGroupByDropdown == true) // visa inte där showInGroupByDropdown är false
      .map(col => ({
        value: {
          column_type: col.column_type,
          display_name: col.display_name
        },
        text: col.display_name + (!col.optionalForRoF ? " *" : ""),
        disabled: col.disabled
      }))
  },
  // ingen ska vara förvald, i frågorna till API så läggs alla till ifall man inte har valt något
  default: []
});

export const transformToDisplayColumnsFromAPIResponse = columnTypes => ({
  config: {
    options: columnTypes
      .filter(col => col.hidden == false) // visa inte gömda kolumner
      .map(col => ({
        value: {
          column_type: col.column_type,
          display_name: col.display_name
        },
        text: col.display_name,
        disabled: col.disabled
      }))
  },
  // lägg till de som ska vara förvalda
  default: columnTypes
    .filter(col => col.default_selection)
    .map(col => ({
      column_type: col.column_type,
      display_name: col.display_name
    }))
});
export const transformToToplistColumns = columnTypes => {
  return columnTypes.map(col => ({
    column_type: col.column_type,
    display_name: col.display_name
  }));
};
export const transformToChannelsFromAPIResponse = channels => ({
  config: {
    tabs: {
      ...channels.reduce(
        (prev, cur) => ({
          ...prev,
          ...{
            [cur.group]: [
              ...(prev[cur.group] ?? []),
              {
                name: cur.channel_name,
                item: cur.orig_code,
                isLog: cur.is_log
              }
            ]
          }
        }),
        {}
      )
    }
  }
});
export const transformToMeasuresFromAPIResponse = measures => ({
  defaultMeasure: {
    bigscreen: measures[0].bigscreen,
    digitaldevices: measures[0].digitaldevices,
    column_type: measures[0].column_type,
    display_name: measures[0].display_name,
    isReach: measures[0].isReach
  },
  measures: measures.filter(m => !m.hide).map(m => ({
    text: m.display_name.replace("(000)", ""),
    value: { 
      column_type: m.column_type, 
      bigscreen: m.bigscreen, 
      digitaldevices: m.digitaldevices, 
      display_name: m.display_name, 
      isReach: m.isReach 
    }
  }))
});
export const transformToGenresFromAPIResponse = genres => ({
  config: {
    genres: [...genres]
  }
});

export const transformToDaypartsFromAPIResponse = dayparts => ({
  config: {
    tabs: {
      ...dayparts.reduce(
        (prev, cur) => ({
          ...prev,
          ...{
            [cur.daypart_type]: [
              ...(prev[cur.daypart_type] ?? []),
              {
                name: cur.daypart_name,
                item: cur.daypart_name
              }
            ]
          }
        }),
        {}
      )
    }
  }
});

export const allWithStarsSelected = (selColumns, columnFieldsOptions) => {

  if (selColumns.length === 0) { return true; }; // 0 valda = alla valda

  let starArray = [];

  columnFieldsOptions.forEach(column => {
    if (column.text.charAt(column.text.length - 1) === "*") {
      starArray.push(column.value.display_name);
    }
  });

  let allStarSelected = true;

  if (starArray.length > 0) {
    starArray.forEach(star => {
      let starFound = false;

      selColumns.forEach(element => {
        if (element.display_name === star) {
          starFound = true;
        }
      });

      if (!starFound) {
        allStarSelected = false;
      }
    });

    return allStarSelected;
  }
};

export const uniqueElementsBy = (arr, fn) =>
  arr.reduce((acc, v) => {
    if (!acc.some(x => fn(v, x))) acc.push(v);
    return acc;
  }, []);
export const transformToToplistPayload = query => {
  let channels = query.channels;
  let toplistPayload = {
    columns: query.columns,
    key_column: query.key_column,
    start_date: query.day,
    end_date: query.day,
    orig_codes: channels ? Object.values(channels).flat() : [],
    measures: query.measures
      ? query.measures.map(measure => {
          let targetGroup = {
            group: measure.group,
            age_from: measure.age_from,
            age_to: measure.age_to
          };
          
          // Add Other target group fields if group is "O"
          if (measure.group === 'O' && measure.othertargetgroups && measure.othertargetgroupsvalues) {
            targetGroup.other_category = measure.othertargetgroups;
            targetGroup.other_value = measure.othertargetgroupsvalues;
          }
          
          return {
            min_viewing_time: 0,
            target_group: targetGroup,
            consolidated: measure.timeshift.consolidated,
            days: measure.timeshift.days,
            timeshift: measure.timeshift.keys,
            display_name: createMeasureName(measure),
            column_type: measure.measure.column_type
          };
        })
      : [],
    sort_by: {
      column_type: query.measures[0].measure.column_type,
      display_name: createMeasureName(query.measures[0])
    },
    tab: "program"
  };
  if (query.groupBy.id === "week") {
    dayjs.extend(isoWeek).extend(weekday);
    let weekdate = dayjs()
      .set("y", query.year)
      .isoWeek(query.week)
      .locale("sv");
    toplistPayload.start_date = weekdate.weekday(0).format("YYYY-MM-DD");
    toplistPayload.end_date = weekdate.weekday(6).format("YYYY-MM-DD");
    toplistPayload.columns = query.columns.filter(
      c => c.column_type !== "week"
    );
  }
  return toplistPayload;
};
/*

Store helpers


*/

export const createMeasureName = measure => {
  let reachCriteria = measure.measure.isReach && measure.reach_criteria ? `,\u00A0${measure.reach_criteria}\u00A0min` : "";
  let group = measure.group == "K" ? "W" : measure.group;
  
  // Handle "Other" target groups - show the compact text instead of age range
  let targetGroupPart;
  if (group === "O" && measure.othertargetgroupsvaluesText) {
    targetGroupPart = measure.othertargetgroupsvaluesText;
  } else if (group === "O" && measure.othertargetgroupsvalues) {
    // Fallback to value if text is not available
    targetGroupPart = measure.othertargetgroupsvalues;
  } else {
    targetGroupPart = `${group}${measure.age_from}-${measure.age_to}`;
  }
  
  return `${measure.measure.display_name}\n${targetGroupPart} [${measure.timeshift.group}${reachCriteria}]`;
};
export function takeElementsUpTo100Chars(arr) {
  let totalChars = 0;
  const resultArray = [];

  for (let i = 0; i < arr.length; i++) {
    const currentLength = arr[i].length;

    // Check if adding the next element exceeds 200 characters
    if (totalChars + currentLength > 100) {
      break; // Stop iteration if adding the next element exceeds 200 characters
    }

    // Add the current element to the result array
    resultArray.push(arr[i]);

    // Update the total character count
    totalChars += currentLength;
  }

  return resultArray;
}

export function getHeaderStreamingTab(context, tab, currentClientVersion) {
  let today = new Date();
  let channelNames = context.getters.getStreamingDomainGroups.filter(p => p.activeChannels);
  let siteNames = context.getters.getStreamingDomainGroups.filter(p => p.activeDomains);
  let chosenChannels =
    context.getters.getStreamingQueryForAPI.domainGroups.length < 1
      ? channelNames.map(p => p.activeChannels).join(", ")
      : channelNames
        .filter(p => context.getters.getStreamingQueryForAPI.domainGroups.includes(p.value))
        .map(p => p.activeChannels)
        .join(", ");
  let chosenSites =
    context.getters.getStreamingQueryForAPI.domainGroups.length < 1
      ? siteNames.map(p => p.activeDomains).join(", ")
      : siteNames
        .filter(p => context.getters.getStreamingQueryForAPI.domainGroups.includes(p.value))
        .map(p => p.activeDomains)
        .join(", ");
  const result = [
    ["Analysis date", `${today.toISOString().split("T")[0]} ${today.getHours()}:${today.getMinutes()}`],
    ["Tool", tab],
    ["Client version, API", currentClientVersion],
    ["Consumption period", context.getters.getStreamingQueryForAPI.start_date, context.getters.getStreamingQueryForAPI.end_date],
    ["Channels/sites", chosenChannels, chosenSites],
    [], [],
  ].filter(Boolean);
  return result;
}
